import type { infer as zInfer } from "zod/v4";
import { number, object } from "zod/v4";

export const getKatanaIntegration = {
  name: "getKatanaIntegration" as const,
  input: object({}),
  output: object({
    katanaIntegration: object({ restockLocationId: number() }).optional(),
  }),
};

export type KatanaIntegration = zInfer<typeof getKatanaIntegration.output>;
